<template>
  <div class="Profile container">
    <div class="Head">
      <span>{{ $t("pages.ec_edit.title") }}</span>

      <router-link to="/org/profile" class="btn-back">
        <img src="./../../assets/img/ReDesign/interface_icons/arrow_back.svg" alt=""/>
      </router-link>
    </div>

    <div class="Body">
      <div v-for="(block, bindx) in form" :key="`block-${bindx}`" class="Block">
        <span class="Title">{{ $t(block.title) }}</span>
        <div class="Form">
          <div
            v-for="(fieldblock, fbindx) in block.fields"
            :key="`fieldblock-${fbindx}`"
            class="BlockLine"
          >
            <template v-if="fieldblock.type === 'single'">
              <template v-if="fields[fieldblock.field].type === 'avatar'">
                <div
                  class="Avatar"
                  @click="avatarUploadModalShowed = !avatarUploadModalShowed"
                >
                  <div
                    v-if="getAvatar != null"
                    class="AvatarIMG"
                    :style="
                      `background: url('${getAvatar}'); background-size: contain;`
                    "
                  ></div>
                  <div v-else class="AvatarIMG"></div>
                  <div class="AvatarBG"></div>
                </div>

                <span
                  v-if="fields[fieldblock.field].label != null"
                  class="BLLabel"
                  style="font-size: 14px"
                >
                  <span>{{ $t(fields[fieldblock.field]?.label) }}</span>
                  <span
                    v-if="fields[fieldblock.field]?.required === true"
                    :style="`color: ${fields[fieldblock.field]?.req_color}`"
                  >
                    {{ $t(fields[fieldblock.field]?.req_text) }}
                  </span></span
                >
              </template>

              

              <template v-if="fields[fieldblock.field].type === 'text'">
                <DefaultInput
                  v-model="fields[fieldblock.field].value"
                  @update:modelStatus="fields[fieldblock.field].validate = $event"
                  :placeholder="
                    fields[fieldblock.field]?.placeholder
                      ? $t(fields[fieldblock.field]?.placeholder) : ''
                  "
                  :isNull="!fields[fieldblock.field].required"
                  :type="fieldblock.field === 'email' ? 'email' : 'text'"
                />
              </template>

              <template v-if="fields[fieldblock.field].type === 'text_array'">
                <div class="textsArray">
                  <div
                    v-for="(taf, tafndx) in fields[fieldblock.field].value"
                    :key="tafndx"
                    class="textsWrap"
                  >
                    <DefaultInput
                      v-model="taf.link"
                      :placeholder="$t(tafndx === 0 ? fields[fieldblock.field].placeholder : '')"
                    />
                    <div
                      v-if="tafndx !== 0"
                      class="removeIcon"
                      @click="
                        removeFromList(fields[fieldblock.field].value, tafndx)
                      "
                    ></div>
                  </div>
                </div>
              </template>

              <template v-if="fields[fieldblock.field].type === 'textarea'">
                <DefaultTextarea
                  v-model="fields[fieldblock.field].value"
                  @update:modelStatus="fields[fieldblock.field].validate = $event"
                  :placeholder="
                    fields[fieldblock.field]?.placeholder
                      ? $t(fields[fieldblock.field]?.placeholder) : ''
                  "
                  :maxLength=1000
                  :isNull="!fields[fieldblock.field].required"
                />
              </template>

              <template v-if="fields[fieldblock.field].type === 'yandexMap'">
                <DefaultInput
                  v-model="fields[fieldblock.field].value"
                  @update:modelStatus="fields[fieldblock.field].validate = $event"
                  :placeholder="
                    fields[fieldblock.field]?.placeholder
                      ? $t(fields[fieldblock.field]?.placeholder) : ''
                  "
                  :isNull="!fields[fieldblock.field].required"
                  type="yandexMap"
                />
              </template>

              <template v-if="fields[fieldblock.field].type === 'btn'">
                <div
                  :class="fields[fieldblock.field].class"
                  @click="formButtonHandler(fieldblock.field)"
                >
                  <img
                    v-if="fields[fieldblock.field]?.need_icon === true"
                    :src="fields[fieldblock.field].icon"
                    alt=""
                  />
                  <span>{{ $t(fields[fieldblock.field].value) }}</span>
                </div>
              </template>
            </template>

            <template v-if="fieldblock.type === 'line-horizontal-primary'">
              <div
                class="grid-line-elements"
                :style="
                  `grid-template-columns: 264px repeat(${fieldblock.fields
                    .length - 1}, minmax(0,1fr));`
                "
              >
                <div
                  v-for="(_field, _findx) in fieldblock.fields"
                  :key="`_field-${_findx}`"
                  class="BlockLine"
                >
                  <template v-if="fields[_field].type === 'text'">
                    <DefaultInput
                      v-model="fields[_field].value"
                      @update:modelStatus="fields[_field].validate = $event"
                      :label="
                        fields[_field]?.label
                          ? $t(fields[_field]?.label) : ''
                      "
                      :placeholder="
                        fields[_field]?.placeholder
                          ? $t(fields[_field]?.placeholder) : ''
                      "
                      :isNull="!fields[_field].required"
                    />
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="Buttons">
        <div 
          class="btn-router-link btnSave" 
          :class="validateSuccess ? 'btn-n-yellow' : 'btn-n-yellow-disabled'"
          @click="saveProfileEdit"
        >
          <span>{{ $t("pages.ec_edit.form.buttons.save") }}</span>
        </div>
        <router-link 
          to="/org/profile" 
          class="btn-n-white-no-border btn-router-link btnSave"
        >
          <span>{{ $t("pages.ec_edit.form.buttons.cancel") }}</span>
        </router-link>
      </div>
    </div>

    <div
      v-if="avatarUploadModalShowed"
      class="AvatarUploadModalWrapper"
      @click.self="avatarUploadModalShowed = !avatarUploadModalShowed"
    >
      <div class="AvatarUploadModal">
        <div class="AUContent">
          <div class="AUTitle noselect">
            <span>{{
              $t("pages.ec_edit.form.avatar_upload_modal.title")
            }}</span>
            <div
              class="Close"
              @click.self="avatarUploadModalShowed = !avatarUploadModalShowed"
            ></div>
          </div>

          <ImageCropper :getResult="getCroppedAvatar" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { transformUrl } from "@/utils/transformUrl.js";
import { mapGetters, mapMutations } from "vuex";
import { findById } from "@/api/user.js";
import { refresh } from "@/api/auth.js";
import { getShortInfo, setShortInfo } from "@/api/company.js";

import ImageCropper from "@/components/ImageCropper";
import DefaultInput from "@/components/OctaUI/Inputs/DefaultInput.vue";
import DefaultTextarea from "@/components/OctaUI/Inputs/DefaultTextarea.vue";

import "@/assets/css/Repainting/Buttons.css";

export default {
  components: {
    ImageCropper,
    DefaultInput,
    DefaultTextarea
  },  
  data() {
    return {
      fields: {
        avatar: {
          type: "avatar",
          value: null,
          label: "pages.ec_edit.form.fields.avatar.label",
          required: true,
          validate: false,
          req_text: "pages.ec_edit.form.fields.avatar.req_text",
          req_color: "#DC3545",
        },
        name: {
          type: "text",
          value: "",
          placeholder: "pages.ec_edit.form.fields.name.placeholder",
          required: true,
          validate: false,
          req_text: "pages.ec_edit.form.fields.name.req_text",
          req_color: "#666666",
        },
        desc: {
          type: "textarea",
          value: "",
          placeholder: "pages.ec_edit.form.fields.desc.placeholder",
          required: true,
          validate: false,
          req_text: "pages.ec_edit.form.fields.desc.req_text",
          req_color: "#DC3545",
        },
        region: {
          type: "text",
          value: "",
          placeholder: "pages.ec_edit.form.fields.region.label",
          required: true,
          validate: false,
          req_text: "pages.ec_edit.form.fields.region.req_text",
          req_color: "#DC3545",
        },
        street: {
          type: "text",
          value: "",
          label: "pages.ec_edit.form.fields.street.label",
          placeholder: "pages.ec_edit.form.fields.street.label",
          required: true,
          validate: false,
          req_text: "pages.ec_edit.form.fields.street.req_text",
          req_color: "#DC3545",
        },
        house: {
          type: "text",
          value: "",
          label: "pages.ec_edit.form.fields.house.label",
          placeholder: "pages.ec_edit.form.fields.house.label",
          required: true,
          validate: false,
          req_text: "pages.ec_edit.form.fields.house.req_text",
          req_color: "#DC3545",
        },
        building: {
          type: "text",
          value: "",
          label: "pages.ec_edit.form.fields.building.label",
          placeholder: "pages.ec_edit.form.fields.building.label",
          required: false,
          validate: false,
        },
        floor: {
          type: "text",
          value: "",
          label: "pages.ec_edit.form.fields.floor.label",
          placeholder: "pages.ec_edit.form.fields.floor.label",
          required: true,
          validate: false,
          req_text: "pages.ec_edit.form.fields.floor.req_text",
          req_color: "#DC3545",
        },
        office: {
          type: "text",
          value: "",
          label: "pages.ec_edit.form.fields.office.label",
          placeholder: "pages.ec_edit.form.fields.office.label",
          required: false,
          validate: false,
        },
        orientir: {
          type: "textarea",
          value: "",
          placeholder: "pages.ec_edit.form.fields.orientir.placeholder",
          required: false,
          validate: false,
        },
        yandex_map_link: {
          type: "yandexMap",
          value: "",
          placeholder: "pages.ec_edit.form.fields.yandex_map_link.placeholder",
          required: false,
          validate: false,
        },
        site: {
          type: "text",
          value: "",
          placeholder: "pages.ec_edit.form.fields.site.label",
          required: false,
          validate: false,
        },
        phone: {
          type: "text",
          value: "",
          placeholder: "pages.ec_edit.form.fields.phone.label",
          required: false,
          validate: false,
        },
        email: {
          type: "text",
          value: "",
          placeholder: "pages.ec_edit.form.fields.email.label",
          required: false,
          validate: false,
        },
        social: {
          type: "text_array",
          value: [
            {
              id: null,
              link: "",
            },
          ],
          placeholder: "pages.ec_edit.form.fields.social.label",
          required: false
        },
        btn_add_link: {
          type: "btn",
          class: "btn",
          value: "pages.ec_edit.form.fields.btn_add_link.value",
          need_icon: true,
          icon: require("./../../assets/img/ReDesign/interface_icons/Add_Plus_Circle.svg"),
          required: false,
        },
      },

      form: [
        {
          title: "pages.ec_edit.form.title",
          fields: [
            {
              type: "single",
              field: "avatar",
            },
            {
              type: "single",
              field: "name",
            },
            {
              type: "single",
              field: "desc",
            },
          ],
        },

        {
          title: "pages.ec_edit.form.title_location",
          fields: [
            {
              type: "single",
              field: "region",
            },
            {
              type: "line-horizontal-primary",
              fields: ["street", "house", "building", "floor", "office"],
            },
            {
              type: "single",
              field: "orientir",
            },
            {
              type: "single",
              field: "yandex_map_link",
            },
          ],
        },

        {
          title: "pages.ec_edit.form.title_contact",
          fields: [
            {
              type: "single",
              field: "site",
            },
            {
              type: "single",
              field: "phone",
            },
            {
              type: "single",
              field: "email",
            },
            {
              type: "single",
              field: "social",
            },
            {
              type: "single",
              field: "btn_add_link",
            },
          ],
        },
      ],

      ta_max_length: 1000,

      avatarUploadModalShowed: false,
      avatarPreloaded: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/isLoggedIn",
    }),

    validateSuccess() {
      return (
        this.fields.name.validate &&
        this.fields.desc.validate &&
        this.fields.region.validate &&
        this.fields.street.validate &&
        this.fields.house.validate &&
        this.fields.floor.validate &&
        this.fields.orientir.validate &&
        this.fields.email.validate &&
        this.fields.yandex_map_link.validate
      );
    },

    getAvatar() {
      if (this.fields.avatar.value != null) {
        return this.fields.avatar.value;
      }

      if (this.avatarPreloaded != null) {
        return transformUrl(this.avatarPreloaded);
      }

      return null;
    },
  },
  async created() {
    if (this.user == null) {
      this.updateUser();
    } else {
      this.getUser(this.user.id);
    }

    try {
      let edCenterResp = await getShortInfo({
        EdCenterID: this.user.parent_company[0]?.id,
        AuthorID: this.user.id,
      });

      if (
        edCenterResp.data.avatar_url != null &&
        edCenterResp.data.avatar_url != ""
      ) {
        this.avatarPreloaded = edCenterResp.data.avatar_url;
      }

      this.fields.name.value = edCenterResp.data.name || "";
      this.fields.desc.value = edCenterResp.data.desc || "";

      let splitedAddress =
        edCenterResp.data.address != null &&
        typeof edCenterResp.data.address === "string"
          ? edCenterResp.data.address.split("{%;%}")
          : [];
      this.fields.region.value = splitedAddress?.[0] || "";
      this.fields.street.value = splitedAddress?.[1] || "";
      this.fields.house.value = splitedAddress?.[2] || "";
      this.fields.building.value = splitedAddress?.[3] || "";
      this.fields.floor.value = splitedAddress?.[4] || "";
      this.fields.office.value = splitedAddress?.[5] || "";

      this.fields.orientir.value = edCenterResp.data?.orientir || "";

      this.fields.site.value = edCenterResp.data?.site || "";

      let splitedContacts =
        edCenterResp.data.contacts != null &&
        typeof edCenterResp.data.contacts === "string"
          ? edCenterResp.data.contacts.split("{%;%}")
          : [];
      this.fields.phone.value = splitedContacts?.[0] || "";
      this.fields.email.value = splitedContacts?.[1] || "";

      if (
        edCenterResp.data?.social_links != null &&
        edCenterResp.data?.social_links.length >= 1
      ) {
        this.fields.social.value = edCenterResp.data?.social_links;
      }

      this.fields.yandex_map_link.value = edCenterResp.data?.yandex_map_link;
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    ...mapMutations("auth", ["SET_USER"]),
    async updateUser() {
      const response = await refresh();
      const userResponse = response.user;
      this.getUser(userResponse.id);
    },
    getUser(id) {
      if (id != undefined) {
        findById(id).then((response) => {
          this.SET_USER(response.data);
        });
      }
    },

    formButtonHandler(fieldName) {
      switch (fieldName) {
        case "btn_add_link": {
          this.fields.social.value.push({
            id: null,
            link: "",
          });
          return;
        }
      }
    },

    async saveProfileEdit() {
      try {
        let textData = {
          EdCenterID: this.user.parent_company[0]?.id,
          AuthorID: this.user.id,
          name: this.fields.name.value,
          desc: this.fields.desc.value,
          address: `${this.fields.region.value}{%;%}${this.fields.street.value}{%;%}${this.fields.house.value}{%;%}${this.fields.building.value}{%;%}${this.fields.floor.value}{%;%}${this.fields.office.value}`,
          orientir: this.fields.orientir.value,
          site: this.fields.site.value,
          social_links: this.fields.social.value,
          contacts: `${this.fields.phone.value}{%;%}${this.fields.email.value}`,
          yandex_map_link: this.fields.yandex_map_link.value
        };

        let formData = new FormData();
        formData.append("req_data", JSON.stringify(textData));

        if (this.fields.avatar.value != null) {
          const file = this.dataURLtoFile(
            this.fields.avatar.value,
            "avatar.png"
          );
          formData.append("file", file);
        }

        await setShortInfo(formData);

        this.$router.push("/org/profile");
      } catch (e) {
        alert(this.$t("pages.ec_edit.msg.error"));
      }
    },

    dataURLtoFile(dataUrl, filename) {
      const arr = dataUrl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1]; // например, image/png
      const bstr = atob(arr[1]); // декодируем base64
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    getCroppedAvatar(res) {
      this.fields.avatar.value = res;
      this.avatarUploadModalShowed = false;
    },

    removeFromList(arr, indx) {
      arr = arr.splice(indx, 1);
    },
  },
};
</script>

<style scoped>
.AUTitle > * {
  margin: auto 0%;
}
.AUTitle {
  position: relative;
  display: flex;

  width: auto;
  max-width: 100%;

  flex-direction: row;
  justify-content: space-between;
  gap: 10px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;

  color: #1a1a1a;
}

.Close {
  position: relative;
  display: block;

  width: 40px;
  height: 40px;

  background: url("./../../assets/img/ReDesign/interface_icons/close_modal_16px.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;

  flex-shrink: 0;
}
.AvatarUploadModalWrapper {
  position: fixed;
  display: flex;

  inset: 0;

  width: 100%;
  height: 100svh;

  background-color: rgba(26, 26, 26, 0.6);
  backdrop-filter: blur(10px);

  z-index: 999;
}
.AvatarUploadModal {
  position: relative;
  display: flex;

  margin: auto;
  padding: 40px;

  min-width: 0;
  width: 500px;
  max-width: 95%;

  height: fit-content;
  max-height: 95%;

  border-radius: 24px;
  overflow-y: auto;

  background-color: white;
}
.AUContent {
  position: relative;
  display: flex;

  min-width: 0%;
  width: 100%;

  height: fit-content;
  max-height: 100%;

  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;
}

.container {
  width: 100%;
  max-width: 1168px; /* 1128px content + 20px padding on each side */
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
}

.Profile {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 50px;
}

.Head {
  position: relative;
  display: inline;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Involve";
  font-weight: 600;
  font-size: 32px;
  line-height: 130%;
  letter-spacing: 0%;

  color: #1a1a1a;
}
.Body {
  position: relative;
  display: flex;

  width: 100%;
  max-width: 648px;

  flex-direction: column;
  justify-content: flex-start;
  gap: 40px;
}

.Block {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;
}
.Title {
  position: relative;
  display: inline;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 20px;
  line-height: 130%;
  letter-spacing: 0%;

  color: #1a1a1a;
}
.Form {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
}

.BlockLine {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 0px;
}

input[type="text"]::placeholder {
  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #666666;
}
input[type="text"] {
  position: relative;
  display: block;

  outline: none;

  padding: 15.5px 16px;

  width: 100%;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #1a1a1a;
  background-color: transparent;
  border: 1px solid #666666;

  border-radius: 8px;
}

textarea::placeholder {
  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #666666;
}
textarea {
  position: relative;
  display: block;

  outline: none;

  padding: 20px 16px;

  width: 100%;

  min-height: 195px;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #1a1a1a;
  background-color: transparent;
  border: 1px solid #666666;

  border-radius: 8px;

  resize: vertical;
}

.BLLabel > * {
  margin: auto 0%;
}
.BLLabel {
  position: relative;
  display: flex;

  margin-left: 16px;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 4px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #666666;
}
.TextAreaAvailableSymbols {
  position: relative;
  display: inline;

  margin-left: 16px;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0%;
  color: #666666;
}
.grid-line-elements {
  position: relative;
  display: grid;

  width: 100%;
  height: fit-content;

  align-items: flex-start;
  gap: 8px;
}
.Avatar {
  position: relative;
  display: block;

  cursor: pointer;

  margin-left: 16px;
  margin-bottom: 4px;

  width: 56px;
  height: 56px;

  border-radius: 100%;
  overflow: hidden;
}
.AvatarBG {
  position: absolute;
  display: block;

  inset: 0;

  width: 100%;
  height: 100%;

  background-color: #f8f8f8;

  z-index: 1;
}
.AvatarIMG {
  position: absolute;
  display: block;

  inset: 0;

  width: 100%;
  height: 100%;

  background: url("./../../assets/img/ReDesign/interface_icons/UserDefaultAvatar.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px;

  z-index: 2;
}

.Buttons {
  position: relative;
  display: flex;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;
}
.btn > * {
  margin: auto 0%;
}
.btn {
  position: relative;
  display: flex;

  cursor: pointer;

  padding: 12px 20px;

  width: fit-content;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 10px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  text-decoration: none;

  color: #1a1a1a;
  background-color: transparent;

  border-radius: 8px;
}
.btn.yellow {
  background-color: #f9d773e5;
}
.btn-back {
  position: absolute;
  display: flex;

  width: 48px;
  height: 48px;

  top: 50%;
  left: 0;
  left: -24px;
  transform: translateX(-100%) translateY(-50%);

  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  background: #FFFFFF;

  box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.1), 0px 4px 4px -4px rgba(12, 12, 13, 0.05);
  border-radius: 8px;
  transition: 0.3s;
}
.btn-back:hover {
  transition: 0.3s;
  background: #F8F8F8;
}

.textsArray {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
}

.textsWrap {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;
}
.removeIcon {
  position: absolute;
  display: block;

  cursor: pointer;

  top: 50%;
  right: -19px;

  width: 16px;
  height: 16px;

  transform: translateY(-50%);

  background: url("./../../assets/img/ReDesign/interface_icons/close_icon_24px.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;

  filter: brightness(0) saturate(100%) invert(0%) sepia(100%) saturate(7500%)
    hue-rotate(211deg) brightness(115%) contrast(115%);
}
.Buttons > .btn-router-link {
  width: fit-content;
  height: 48px; 
  font-size: 16px; 
  padding: 8px 16px;
}
</style>

<style scoped>
@media (max-width: 480px) {
}
@media (min-width: 480px) and (max-width: 768px) {
}
@media (min-width: 768px) and (max-width: 992px) {
}
@media (min-width: 992px) and (max-width: 1400px) {
}
@media (min-width: 1400px) and (max-width: 1600px) {
}
@media (min-width: 1600px) {
}

@media (max-width: 768px) {
  .grid-line-elements > .BlockLine:nth-child(1) {
    width: 100%;
  }
  .grid-line-elements > .BlockLine:nth-child(2),
  .grid-line-elements > .BlockLine:nth-child(3),
  .grid-line-elements > .BlockLine:nth-child(4),
  .grid-line-elements > .BlockLine:nth-child(5) {
    width: calc((100% - 8px) / 2);
  }
  .grid-line-elements {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .removeIcon {
    right: 2px;
  }

  .AvatarUploadModal {
    padding: 20px;
  }

  .Buttons {
    width: 100%;
    flex-direction: column;
  }
  .Buttons > .btn-router-link {
    width: 100%;
  }
  .Buttons > .btn > span {
    margin: 0% auto;
  }
}
</style>
